<template>
    <v-card class="px-3 py-2">
        <v-card-text>
            <v-form class="mb-5" height="200px">
                <v-container>
                    <v-row jusify="center">
                        <v-col>
                            <p>
                                Name
                            </p>
                            <v-text-field @change="slugifyName" outlined class="pa-2" v-model="newOffer.name"></v-text-field>
                        </v-col>
                        <v-col>
                            <p>
                                Title
                            </p>
                            <v-text-field class="pa-2" outlined v-model="newOffer.title"></v-text-field>
                        </v-col>
                        <v-col>
                            <p>
                                Expiration Date
                            </p>
                            <v-dialog ref="dialog" v-model="datePickerModal" :return-value.sync="date" persistent full-width width="290px">
                                <template v-slot:activator="{ on }">
                                <v-text-field class="pa-2"  outlined v-model="date" label="Select Date" prepend-icon="event" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker color="#5D337C" v-model="date" scrollable>
                                <div class="flex-grow-1"></div>
                                <v-btn text color="#5D337C" @click="modal = false">Cancel</v-btn>
                                <v-btn text color="#5D337C" @click="$refs.dialog.save(date)">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p>
                                Description
                            </p>
                            <v-input class="pa-2" elevation="3" style="text-align: left; max-width: 100%;">
                                <vue-editor v-model="newOffer.description" :editorToolbar="customToolbar"></vue-editor>
                            </v-input>
                        </v-col>
                        <v-col>
                            <p>
                                Terms
                            </p>
                            <v-input class="pa-2" elevation="3" style="text-align: left; max-width: 100%;">
                                <vue-editor v-model="newOffer.terms" :editorToolbar="customToolbar"></vue-editor>
                            </v-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p>
                                Categories
                            </p>
                            <v-select v-model="newOffer.categories" :items="availableCategories" chips label="Select one or more..." multiple outlined></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p>
                                Slug
                            </p>
                            <v-text-field outlined class="pa-2" v-model="newOffer.slug"></v-text-field>
                        </v-col>
                        <v-col>
                            <p>
                                Button Text
                            </p>
                            <v-text-field class="pa-2" outlined v-model="newOffer.buttonText"></v-text-field>
                        </v-col>
                        <v-col>
                            <p>
                                URL
                            </p>
                            <v-text-field class="pa-2" outlined v-model="newOffer.url"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <p>
                                Logo <small>200 x 200px - w x h</small>
                            </p>
                            <v-text-field outlined label="Select Image" @click="pickLogo" v-model="logoName" prepend-icon="attach_file"></v-text-field>
                            <input type="file" style="display: none" ref="logoImage" accept="image/*" @change="logoPicked">
                            <img :src="newOffer.logoDownloadUrl" width="200px" height="200px" v-if="newOffer.logoDownloadUrl">
                        </v-col>
                        <v-col>
                            <p>
                                Banner <small>1600 x 700px - w x h</small>
                            </p>
                            <v-text-field outlined label="Select Image" @click="pickBanner" v-model="bannerName" prepend-icon="attach_file"></v-text-field>
                            <input type="file" style="display: none" ref="bannerImage" accept="image/*" @change="bannerPicked">
                            <img :src="newOffer.bannerDownloadUrl" width="100%" v-if="newOffer.bannerDownloadUrl">
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <span class="mr-3">{{ contentError }}</span>
                        <v-btn class="button-style" dark elevation="0" color="green" v-if="newOffer.bannerDownloadUrl && newOffer.logoDownloadUrl" @click="addOffer()">
                            Save
                        </v-btn>
                        <v-btn class="button-style" dark elevation="0" color="green" v-else @click="validateContent()">
                            Upload Images
                        </v-btn>
                        <v-btn @click="$emit('clicked')" elevation="0" color="red" class="button-style" dark> 
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-container>
            </v-form>
        </v-card-text>
    </v-card>
</template>
<script>
import slugify from 'slugify'
import uuid from 'uuidv4'
import { VueEditor } from 'vue2-editor'
export default {
    components: {
        VueEditor
    },
    computed: {
        availableCategories() {
            return this.$store.getters.availableCategories
        }
    },
    data() {
        return {
            date: new Date().toISOString().substr(0, 10),
            datePickerModal: false,
            logoUrl: '',
            logoFile: '',
            logoName: '',
            newLogoUrl: '',
            bannerUrl: '',
            bannerFile: '',
            bannerName: '',
            logoValid: false,
            bannerValid: false,
            contentError: '',
            customToolbar: [
                ['bold', 'italic', 'underline'],
                ['clean'],
            ],
            newOffer: {
                slug: 'cafe-rouge',
                logoDownloadUrl: null,
                bannerDownloadUrl: null,
                name: 'Cafe Rouge',
                title: 'Tuck into a delicious meal with 12% off!',
                description: 'Open for breakfast, lunch and dinner, Cafe Rouge is the perfect spot for some scrumptious French cuisine. Grab your Perkbox voucher and you can tuck into a Burger, Croque with Frites or House Salad for just £5! That leaves more cash in your wallet to spend on a glass of wine (or two… or three).',
                buttonText: 'View Menu',
                url: 'https://caferouge.com',
                terms: 'Present a valid offer code to receive a complimentary Burger, Croque with Frites or House Salad. Burger toppings, drinks, side orders, steak sauces, desserts and service charge are not included. Sweet Potato Frites are available for a £1 supplement. Valid for eat-in only. Valid from 12pm except Saturdays, bank holidays, Valentine’s Day, Mother’s Day, Father’s Day and New Year’s Eve Your code will be checked against a live database and incorrect or previously used codes will not be accepted.',
                categories: [],
                steps: [
                    'Make sure you have access to Vaboo Premium Discounts',
                    'Click the View Offer button',
                    'Continue within the Vaboo Premium Platform'
                ],
                highlights: [
                    'Burgers are included!',
                    'something else great about this offer'
                ]
            }
        }
    },
    methods: {
        slugifyName(){
            this.newOffer.slug = slugify(this.newOffer.name)
        },
        pickLogo() {
            this.$refs.logoImage.click();
        },
        logoPicked(e) {
            const files = e.target.files
            if (files[0] !== undefined) {
                this.logoName = files[0].name
                if (this.logoName.lastIndexOf(".") <= 0) {
                    return
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener("load", () => {
                    this.logoUrl = fr.result
                    this.logoFile = files[0] // this is the image file that is sent to the server
                })
                this.logoValid = true
            } else {
                this.logoName = ""
                this.logoFile = ""
                this.logoUrl = ""
                this.logoValid = false
            }
        },
        pickBanner() {
            this.$refs.bannerImage.click()
        },
        bannerPicked(e) {
            const files = e.target.files
            if (files[0] !== undefined) {
                this.bannerName = files[0].name
                if (this.bannerName.lastIndexOf(".") <= 0) {
                    return
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener("load", () => {
                    this.bannerUrl = fr.result
                    this.bannerFile = files[0] // this is the image file that is sent to the server
                })
                this.bannerValid = true
            } else {
                this.bannerName = ""
                this.bannerFile = ""
                this.bannerUrl = ""
                this.bannerValid = false
            }
        },
        validateContent() {
            // add more validation variables here
            if(this.logoValid !== true || this.bannerValid !== true){
                this.contentError = 'Everything needs to be completed...'
            }else{
                this.saveLogo()
                this.saveBanner()
            }
        },
        addOffer() {
            firebase.firestore().collection('content').doc('offers').collection('basic-offers').doc(this.newOffer.slug).set(this.newOffer)
            .then(() => {
                this.$emit('clicked')
            })
            .catch(err => {
                this.contentError = err.message
            })
        },
        saveLogo() {
            var storageRef = firebase.storage().ref()
            var logoFileTemp = this.logoFile
            var metadata = {
                contentType: 'image/png'
            }
            const uploadTask = storageRef.child(`offers/` + this.newOffer.slug + '-logo.png').put(logoFileTemp, metadata)
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
                    switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        break;
                    }
            }, (error) => {
                switch (error.code) {
                    case 'storage/unauthorized':
                    break;
                    case 'storage/canceled':
                    break;
                    case 'storage/unknown':
                    break;
                }
            }, () => {
                var that = this
                uploadTask.snapshot.ref.getDownloadURL().then(function(linkhere) {
                    that.newOffer.logoDownloadUrl = linkhere
                })
            })     
        },
        saveBanner(){
            var storageRef = firebase.storage().ref()
            var bannerFileTemp = this.bannerFile
            var metadata = {
                contentType: 'image/png'
            }
            const uploadTask = storageRef.child(`offers/` + this.newOffer.slug + '-banner.png').put(bannerFileTemp, metadata)
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
                    switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        break;
                    }
            }, (error) => {
                switch (error.code) {
                    case 'storage/unauthorized':
                    break;
                    case 'storage/canceled':
                    break;
                    case 'storage/unknown':
                    break;
                }
            }, () => {
                var thing = this
                uploadTask.snapshot.ref.getDownloadURL().then(function(anotherlinkhere) {
                    thing.newOffer.bannerDownloadUrl = anotherlinkhere
                })
            })
        },
        remove (item) {
            this.newOffer.tags.splice(this.newOffer.tags.indexOf(item), 1)
            this.newOffer.tags = [...this.newOffer.tags]
        },
    },
    created() {
        this.$store.dispatch('setAvailableCategories')
    }
}

</script>

<style>

</style>
